import { createSlice } from "@reduxjs/toolkit";
import { fetchAddressByCep } from "./thunks";
import { toast } from "react-toastify";

interface AddressState {
  street: string;
  neighborhood: string;
  city: string;
  state: string;
  country: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: AddressState = {
  street: "",
  neighborhood: "",
  city: "",
  state: "",
  country: null,
  loading: false,
  error: null,
};

const addressSlice = createSlice({
  name: "address",
  initialState,
  reducers: {
    clearAddress: (state) => {
      state.street = "";
      state.neighborhood = "";
      state.city = "";
      state.state = "";
      state.country = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAddressByCep.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAddressByCep.fulfilled, (state, action) => {
        state.street = action.payload.logradouro;
        state.neighborhood = action.payload.bairro;
        state.city = action.payload.localidade;
        state.state = action.payload.uf;
        state.country = "BR";
        state.loading = false;
      })
      .addCase(fetchAddressByCep.rejected, (state, action) => {
        state.error =
          typeof action.payload === "string"
            ? action.payload
            : "Erro desconhecido";
        state.loading = false;
        toast.error(state.error);
      });
  },
});

export const { clearAddress } = addressSlice.actions;
export default addressSlice.reducer;
